// eslint-disable-next-line @tseslint/typedef
export const CUSTOMER_ROUTES_PARAM_MAPS = {
  customerNumber: "customerNumber"
} as const;
